import React from 'react';
import { METHOD_PAYMENT_TYPE_MONEY } from '../../../Utils/Constants/Checkout';
import { useTranslation } from 'react-i18next';
import { useCheckoutContext } from '../../../Contexts/CheckoutContext';
import Badge from '../Badge';
import { formatCurrency } from '../../../Utils/Formatters';


interface BadgeChangeAmountProps {
    method: any;
}
const BadgeChangeAmount = ({ method }: BadgeChangeAmountProps) => {

    const { paymentMethod } = useCheckoutContext();

    const { t } = useTranslation();

    if (paymentMethod?.type !== METHOD_PAYMENT_TYPE_MONEY || method?.type !== METHOD_PAYMENT_TYPE_MONEY) return null;

    return (
        <div className='grid w-fit ring-1 ring-gray-100 text-xs items-center leading-none gap-1 p-1 rounded-md text-gray-500'>
            <span className='flex-1 min-w-18 text-center font-medium'>
                {paymentMethod?.cash_amount > 0 
                    ?   <span className='text-nowrap'>{t('checkout.change_amount.badge_label')}</span>
                    :   t('checkout.change_amount.badge_label_no_ned')
                }
            </span>
            {paymentMethod?.cash_amount > 0 && <div className='flex items-center justify-center'><Badge outline className='text-xs w-fit rounded-full'>{ formatCurrency(paymentMethod.cash_amount)}</Badge></div>}
        </div>
    )

}

export default BadgeChangeAmount;
